import React, { useEffect } from 'react';
import { Container, Typography, Grid, CardMedia, Box } from '@mui/material';
import Nav from '../Nav';
import englishcareer from '../Images/english_career/english_bg.jpg';
import image1 from '../Images/english_career/1.png';
import image2 from '../Images/english_career/2.png';
import image3 from '../Images/english_career/3.png';
import image4 from '../Images/english_career/4.png';
import image5 from '../Images/english_career/5.png';
import 'aos/dist/aos.css';
import AOS from 'aos';
import PronunciationSection from '../../../src/component/Home/Pronoucation'
const EnglishForCareer = () => {
    useEffect(() => {
        AOS.init({ duration: 500 });
    }, []);

    return (
        <>
            <Nav />
            <Box sx={{
                backgroundColor : '#fffff0'
            }}>
                <Box
                    sx={{
                        backgroundImage: `url(${englishcareer})`,
                        backgroundSize: 'cover',
                        py: 14,
                        textAlign: 'center',
                        color: '#fff',
                        marginBottom: '30px',
                    }}
                    style={{ maxHeight: '280px' }}
                    data-aos="fade"
                >
                    <Container maxWidth="lg">
                        <Typography
                            variant="h1"
                            align="center"
                            gutterBottom
                            sx={{ fontWeight: 'bold', fontFamily: 'Arial, sans-serif', color: '#fff' }}
                            style={{ marginTop: '20px', maxHeight: '250px' }}
                        >
                            English For Career
                        </Typography>
                    </Container>
                </Box>

                <Container
                    maxWidth="lg"
                    sx={{
                        backgroundColor: '#fffff0',
                        p: 5,
                        borderRadius: 2,
                        mt: -8,
                    }}
                    style={{ marginTop: '20px' }}
                >
                    <Typography
                        variant="body1"
                        paragraph
                        sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c', fontWeight: 'bold', fontStyle: 'italic' }}
                        data-aos="fade"
                        style={{ marginTop: '30px' }}
                    >
                        Highlight Your Company’s Global Potential Through English Proficiency
                    </Typography>

                    <Typography
                        variant="body1"
                        paragraph
                        sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}
                        data-aos="fade"
                        data-aos-delay="200"
                    >
                        In today’s global marketplace, the clarity of your team’s <i>communication is not just an asset, it’s a competitive edge.</i> We understand the pivotal role that <b>proficient English</b> plays in every aspect of international business, from customer service to <i>high-stakes business negotiations.</i> That’s why enhancing <i>your employees' English skills</i> is not merely an investment in their professional growth, but a strategic investment in the heart of your business's success.
                    </Typography>

                    <Grid container spacing={4}>
                        <Grid item xs={12} lg={6}>
                            <CardMedia
                                component="img"
                                image={image1}
                                alt="Customer Support"
                                sx={{
                                    width: '100%',
                                    borderRadius: 2,
                                    marginBottom: '16px',
                                }}
                                data-aos="fade-up"
                                data-aos-delay="200"
                            />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Typography
                                variant="body1"
                                paragraph
                                sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}
                                data-aos="fade"
                                data-aos-delay="200"
                                style={{ marginTop: '20px' }}
                            >
                                <b><i><u>For Your Customer Support Representatives:</u></i></b> Equip them with <i>superior listening and precise pronunciation skills.</i> This will enable them to <i>effectively understand and resolve customer issues,</i> increasing satisfaction and loyalty. <i>Clear communication</i> reduces misunderstandings and builds trust, translating directly into better service outcomes and a stronger brand reputation.
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={4} style={{ marginTop: '20px' }}>
                        <Grid item xs={12} lg={6}>
                            <Typography
                                variant="body1"
                                paragraph
                                sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}
                                data-aos="fade"
                                data-aos-delay="200"
                                style={{ marginTop: '20px' }}
                            >
                                <b><i><u>For Your Project Managers:</u></i></b> Imagine your projects running smoother than ever and meeting deadlines. <i>With improved speaking skills,</i> your managers can confidently lead, inspiring their teams. <i>Improved listening abilities</i> ensure they capture every detail, aligning international projects closely with strategic objectives. This leads to on-time, on-spec project delivery that can define market success.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <CardMedia
                                component="img"
                                image={image2}
                                alt="Project Managers"
                                sx={{
                                    width: '100%',
                                    borderRadius: 2,
                                    marginBottom: '16px',
                                }}
                                data-aos="fade-up"
                                data-aos-delay="200"
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={4} style={{ marginTop: '20px' }}>
                        <Grid item xs={12} lg={6}>
                            <CardMedia
                                component="img"
                                image={image3}
                                alt="Sales Managers"
                                sx={{
                                    width: '100%',
                                    borderRadius: 2,
                                    marginBottom: '16px',
                                }}
                                data-aos="fade-up"
                                data-aos-delay="200"
                            />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Typography
                                variant="body1"
                                paragraph
                                sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}
                                data-aos="fade"
                                data-aos-delay="200"
                                style={{ marginTop: '20px' }}
                            >
                                <b><i><u>For Your Sales Managers:</u></i></b> Every word counts in sales. <i>With refined English skills,</i> your sales team can negotiate more effectively, tailoring their pitches to meet the nuanced needs of diverse clients. The <i>pronunciation that commands respect</i> and clarity that convinces are tools that turn potential leads into profitable deals.
                            </Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={4} style={{ marginTop: '20px' }}>
                        <Grid item xs={12} lg={6}>
                            <Typography
                                variant="body1"
                                paragraph
                                sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}
                                data-aos="fade"
                                data-aos-delay="200"
                                style={{ marginTop: '20px' }}
                            >
                                <b><i><u>For Your Technical Support Engineers:</u></i></b> In the technical realm, precision is non-negotiable. <i>Clear pronunciation</i> and the ability to explain complex concepts in simple terms ensure that your solutions resonate with users worldwide. This not only cuts down on repeat issues but also <i>boosts user confidence</i> in your products.
                            </Typography>
                        </Grid>
                        <Grid item xs={12} lg={6}>
                           <PronunciationSection/>
                        </Grid>
                    </Grid>

                    <Grid container spacing={4} style={{ marginTop: '20px' }}>
                        <Grid item xs={12} lg={6}>
                            <CardMedia
                                component="img"
                                image={image5}
                                alt="Marketing Specialists"
                                sx={{
                                    width: '100%',
                                    borderRadius: 2,
                                    marginBottom: '16px',
                                }}
                                data-aos="fade-up"
                                data-aos-delay="200"
                            />
                        </Grid>
                        <Grid item xs={12} lg={6}>
                            <Typography
                                variant="body1"
                                paragraph
                                sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}
                                data-aos="fade"
                                data-aos-delay="200"
                                style={{ marginTop: '20px' }}
                            >
                                <b><i><u>For Your Marketing Specialists:</u></i></b> As the architects of your brand’s voice, marketers with <b>proficient English</b> can more effectively gauge and respond to global trends. Their <i>persuasive communication skills</i> amplify your brand’s message across borders, creating campaigns that work and inspire across cultural divides.
                            </Typography>
                        </Grid>
                    </Grid>

                    <Typography
                        variant="body1"
                        paragraph
                        sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}
                        data-aos="fade"
                        data-aos-delay="200"
                    >
                        We believe in the power of communication to transform businesses. By enhancing <i>your team's English skills,</i> you’re not just preparing them for the challenges of today, you’re equipping them for the opportunities of tomorrow.
                    </Typography>

                    <Typography
                        variant="body1"
                        paragraph
                        sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}
                        data-aos="fade"
                        data-aos-delay="200"
                    >
                        Choose to <i>invest in English proficiency;</i> through investing in your company’s future.
                    </Typography>

                    <Typography
                        variant="body1"
                        paragraph
                        sx={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, color: '#6b778c' }}
                        data-aos="fade"
                        data-aos-delay="200"
                    >
                        <b><i>Contact us</i></b> and inform us how English for Career can help your team use English effectively in your work environment.
                    </Typography>
                </Container>
            </Box>
        </>
    );
};

export default EnglishForCareer;
